import { render, staticRenderFns } from "./BosPastFairListing.vue?vue&type=template&id=1c6fd34e&scoped=true"
import script from "./BosPastFairListing.vue?vue&type=script&lang=js"
export * from "./BosPastFairListing.vue?vue&type=script&lang=js"
import style0 from "./BosPastFairListing.vue?vue&type=style&index=0&id=1c6fd34e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6fd34e",
  null
  
)

export default component.exports